import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTriangleRightMedium: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-triangle-right-medium, dropdown, caret"><path d="M9.75 6.75V17.25L16 12L9.75 6.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconChevronTriangleRightMedium;
